import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { NavItemComp } from 'atoms/NavItems/Presentation/NavItemComp';
import ImageComponent from 'atoms/Image';
import HEADER_DATA from '../Data/SampleData';
import HEADER_CONSTANT from '../HeaderConstants/HeaderConstant';
import { SelectOptions } from 'atoms/DropDown';
import { modifyData } from '../HeaderUtilities/HeaderUtils';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import MenuIcon from 'styles/staticAssets/images/MenuIcon.svg';
import HeaderLogo from 'styles/staticAssets/images/kfcLogo.svg';
import CartIcon from 'styles/staticAssets/images/Bucket-Cart.svg';
import { HeaderMenu } from './HeaderMobileMenu';
import {
  getFromLocalStorage,
  getValueOrDefaultObject,
  getValueOrDefaultAlternativeObject,
  getEmptyObjectforNull,
  getTernaryValue,
  getFilteredItems,
  getAndCheck,
} from 'common/utilities/utils';
import { USER_SELECTED_LANGUAGE } from 'common/constants/SharedConstants';
import { Config } from '../../../common/constants/SharedConstants';
import { ChannelManager } from 'common/manager';
import { login } from 'common/utilities/LoginUtils';

/**
 * Main Header Items Component
 * @param {*} props - Object - title
 */
const getImgStyle = showImg => {
  if (showImg) {
    return ' itemCountActive';
  } else {
    return '';
  }
};

const getIconStyle = showImg => {
  if (showImg) {
    return ' iconActive';
  } else {
    return '';
  }
};

const getCartCount = cartCount =>
  getTernaryValue(
    cartCount > 99,
    <span className='cart-icon-plus'>
      99<span className='cartPlus'>+</span>
    </span>,
    cartCount,
  );

const getNavItemFor100Pecent = (idx, clickHandler, getCartName, item, cartCount, priceCalculation, currencySymbol) => {
  return (
    <NavItemComp
      key={idx}
      onClickHandler={clickHandler}
      name={getValueOrDefaultAlternativeObject(getCartName(item.altText), 'cart')}
      className='cart-image'
    >
      <span className='headerPrice'>{currencySymbol + priceCalculation()}</span>
      <ImageComponent
        srcFile={getValueOrDefaultAlternativeObject(item.url, CartIcon)}
        alt={getValueOrDefaultAlternativeObject(item.altText, 'cart')}
      />
      <span className={`mobileCartIconCount`}>{getCartCount(cartCount)}</span>
    </NavItemComp>
  );
};

const getNavItemFor120Percent = (clickHandler, getCartName, item, cartCount, priceCalculation, currencySymbol) => {
  return (
    <NavItemComp
      onClickHandler={clickHandler}
      name={getValueOrDefaultAlternativeObject(getCartName(item.altText), 'cart')}
      className='cart-image'
    >
      <span className='headerPrice'>{currencySymbol + priceCalculation()}</span>
      <ImageComponent
        srcFile={getValueOrDefaultAlternativeObject(item.url, CartIcon)}
        alt={getValueOrDefaultAlternativeObject(item.altText, 'cart')}
        className='iconActive'
      />
      <span className={'mobileIconCountActive mobileCartIconCount'}>{getCartCount(cartCount)}</span>
    </NavItemComp>
  );
};

const linkCreator = name => {
  switch (name) {
    case 'Menu':
      return '/menu';
    case 'Deals':
      return '/offers';
    default:
      return '';
  }
};

/* Sign in button click */
const signInClick = () => {
  const { ANALYTICS_LOCALISATION_SIGNIN } = START_ORDER_CONSTANTS;
  localStorage.setItem(ANALYTICS_LOCALISATION_SIGNIN, JSON.stringify(true));
  login();
};

const accountPage = (item, loggedIn, history) => {
  if (!item.type && loggedIn && item.name === 'Sign In') {
    history.push({
      pathname: '/account',
    });
  } else {
    signInClick();
  }
};

/**
 *@param {*} rightNavItems - represents all right nav items
 */
const getMobileCardIcon = navRight => navRight.filter(item => item.title === HEADER_CONSTANT.SIGN_IN_LINK);

/* get CartName for Analytics */
const getCartName = cartText => cartText.split(' ')[0];

/**
 * Method to open hamburger modal on header item click
 */
const openHamburgerMenu = headerItemSelected => {
  Boolean(document.querySelector('#headermenu-id')) && (document.querySelector('#headermenu-id').style.width = '100%'); //set modal width as max
  Boolean(document.querySelector('#startorder-container')) &&
    (document.querySelector('#startorder-container').style.display = 'none'); //hide startorder container
  document.body.style.overflowY = 'hidden'; //disable body scroll
};

/*
 * @param {*} element - method to handle close of hamburger modal
 */
const handleClose = () => {
  document.querySelector('#headermenu-id').style.width = '0px'; //set modal width as zero
  document.querySelector('#startorder-container').style.display = 'block'; //display startorder container
  document.body.style.overflowY = 'auto'; //enable body scroll
};

const HeaderItems = props => {
  const [showImg, setShowImg] = useState(false);
  const {
    contentData = {},
    clickHandler = null,
    isMobile = false,
    userParams = {},
    tenantReducerData = {},
    navigateHandler = null,
    dataTestId,
  } = props;

  const {
    basic,
    addHope,
    carryBag,
    country,
    currencyConversionFactor,
    currencySymbol,
    componentOptions: { web: { global: { showPriceWithTax = false } = {} } = {} } = {},
  } = tenantReducerData;
  const {
    navLeft = [],
    navRight = [],
    kfcLogo = {},
    navMobileMenu = {},
  } = getValueOrDefaultObject(modifyData(contentData, basic, country));

  const {
    LANGUAGE_SELECTOR,
    LOGGEDIN_USER_SINGIN_TEXT,
    USER_SINGIN_TEXT,
    CART_ICON_100_PERCENT,
    CART_ICON_120_PERCENT,
    ZERO,
  } = HEADER_CONSTANT;

  navMobileMenu.letsGetCookingText = HEADER_DATA.contentData.headerContent.navMobileMenu.letsGetCookingText;

  const { cartReducer } = useSelector(data => {
    return {
      cartReducer: getValueOrDefaultObject(data.cartReducer),
    };
  });

  const {
    cartData = {},
    isItemAdded = false,
    isUpdateQuantityLoading = false,
    isRemoveItemLoading = false,
  } = getValueOrDefaultObject(cartReducer);

  const { foodLines = [] } = getEmptyObjectforNull(cartData);
  const [cartCount, setCartCount] = useState(0);

  // RENDEV-10995 according to this ticket we are changeing the logic to show the price without tax

  const priceCalculation = () => {
    const intermediatePrice = showPriceWithTax ? cartData?.subtotal + cartData?.taxTotal : cartData?.subtotal;
    const Total = parseFloat(intermediatePrice / currencyConversionFactor).toFixed(2);
    return(
      cartData?.total > ZERO ? Total : ZERO
    )
  };

  useEffect(() => {
    if (foodLines.filter(foodItems => foodItems.item.isHidden).length === 0) {
      if (isItemAdded || isUpdateQuantityLoading || isRemoveItemLoading) {
        setShowImg(true);
      }
    }
  }, [isItemAdded, isUpdateQuantityLoading, foodLines, isRemoveItemLoading]);

  useEffect(() => {
    setTimeout(() => setShowImg(false), 500);
    let addHopeCarryBag = getAndCheck(addHope, carryBag);
    if (addHopeCarryBag) {
      let filteredFoodLineData = getFilteredItems(foodLines, addHope, carryBag);
      setCartCount(_.reduce(filteredFoodLineData, (s, n) => s + n.quantity, 0));
    }
  }, [foodLines, addHope, carryBag]);
  // hard coded to check selections.
  const { defaultLanguage, allowedLanguages, COUNTRY } = useSelector(
    ({ tenantReducer: { basic: { allowedLanguages = [], defaultLanguage } = {}, country: COUNTRY = '' } = {} }) => ({
      allowedLanguages,
      defaultLanguage,
      COUNTRY,
    }),
  );
  //console.log(allowedLanguages)
  const [selectedValue, setSelectedValue] = useState();

  useEffect(() => {
    const localStorageLanguage = allowedLanguages.find(
      item => item.key === getFromLocalStorage(`${COUNTRY}_${USER_SELECTED_LANGUAGE}`),
    );
    !!COUNTRY &&
      setSelectedValue(getValueOrDefaultAlternativeObject(localStorageLanguage?.value, defaultLanguage?.value));
  }, [COUNTRY, allowedLanguages, defaultLanguage?.value]);

  const onRightNavigationClick = param => {
    if (userParams.loggedIn && param === USER_SINGIN_TEXT) {
      clickHandler(LOGGEDIN_USER_SINGIN_TEXT);
    } else {
      clickHandler(param);
    }
  };
  /*  draw header left items */
  const leftNavItems = () => {
    return navLeft.map((item, ind) => {
      return (
        <NavItemComp
          key={ind}
          data-testid={`navItems-component-${item.name}`}
          onClickHandler={clickHandler}
          name={item.name}
          tabIndex='0'
          to={linkCreator(item.name)}
          className='nav-item-left'
        >
          {item.name}
        </NavItemComp>
      );
    });
  };

  /*  draw header right items */
  const rightNavItems = () => {
    return navRight.map((item, ind) => {
      const isCartIcon = [CART_ICON_100_PERCENT, CART_ICON_120_PERCENT].includes(item.title);

      const isUserNotSignedIn = !(ChannelManager.isGoogle && userParams.loggedIn);
      const showIcon =
        (CART_ICON_100_PERCENT === item.title && showImg) || (CART_ICON_120_PERCENT === item.title && !showImg);

      return (
        <NavItemComp
          key={ind}
          onClickHandler={onRightNavigationClick}
          name={item.type || item.name || 'Cart'}
          style={getTernaryValue(showIcon, { display: 'none' }, {})}
          tabIndex='0'
          className={getTernaryValue(ind < navRight.length - 2, 'nav-right-items-line', '')}
          data-id={isUserNotSignedIn ? Config.HEADER_SIGN_IN_ATTR_DATA_ID : null}
        >
          {!isCartIcon && item?.type?.toUpperCase() !== LANGUAGE_SELECTOR && (
            <React.Fragment>
              <div data-testid='account' onClick={() => accountPage(item, userParams.loggedIn, props.history)}>
                <ImageComponent
                  srcFile={getValueOrDefaultAlternativeObject(item.url, item.imageUrl)}
                  className='navRightIcons'
                />
                <span className='notcarticon ml-3'>
                  {getTernaryValue(
                    !item.type && item.name && userParams.loggedIn,
                    LOGGEDIN_USER_SINGIN_TEXT,
                    item.name,
                  )}
                </span>
              </div>
            </React.Fragment>
          )}
          {isCartIcon && <span className='headerPrice'>{currencySymbol + priceCalculation()}</span>}
          {isCartIcon && (
            <div className='cartIcon align-items-center justify-content-center' aria-label='cart' role='button'>
              <ImageComponent
                srcFile={getValueOrDefaultAlternativeObject(item.url, item.imageUrl)}
                className={`navRightIcons ${getIconStyle(showImg)}`}
              />
              <div className={`cartIconCount ${getImgStyle(showImg)}`}>{getCartCount(cartCount)}</div>
            </div>
          )}
          {item.type && item.type.toUpperCase() === LANGUAGE_SELECTOR && (
            <React.Fragment>
              <SelectOptions
                ariaLable='clickable-language-selector'
                tabIndex='-1'
                options={allowedLanguages.map(itemval => itemval?.short_value?.toLowerCase())}
                className='language-select header-language-select'
                selectedValue={selectedValue}
                testid='language-selector'
              />
              <span className='dropdown-img'></span>
            </React.Fragment>
          )}
        </NavItemComp>
      );
    });
  };

  /* draw mobile view header */
  const mobileHeader = (
    <React.Fragment>
      <div className='nav' data-testid='Header-component'>
        <NavItemComp onClickHandler={openHamburgerMenu} name={'Hamburger Menu'} data-testid='hamburger-menu-icon'>
          <ImageComponent srcFile={MenuIcon} alt='Menu' id='BrowserSpecificStyle' />
        </NavItemComp>
        <span className='headerLogoMobile' onClick={navigateHandler}>
          <ImageComponent
            srcFile={getValueOrDefaultAlternativeObject(getMobileCardIcon(navRight).src, HeaderLogo)}
            alt={getValueOrDefaultAlternativeObject(getMobileCardIcon(navRight).alt, 'KFC LOGO')}
          />
        </span>
        {navRight.forEach((item, idx) => {
          if (item.url && CART_ICON_100_PERCENT === item.title && !showImg) {
            return getNavItemFor100Pecent(
              idx,
              clickHandler,
              getCartName,
              item,
              cartCount,
              priceCalculation,
              currencySymbol,
            );
          }
          if (item.url && CART_ICON_120_PERCENT === item.title && showImg) {
            return getNavItemFor120Percent(
              clickHandler,
              getCartName,
              item,
              cartCount,
              priceCalculation,
              currencySymbol,
            );
          }
        })}
      </div>
      <HeaderMenu
        idx='headermenu-id'
        className='sidenav'
        handleClose={handleClose}
        onItemsClickHandler={clickHandler}
        contentData={{ navLeft, navRight, navMobileMenu }}
        userParams={userParams}
      />
    </React.Fragment>
  );

  /*  draw desktop view header*/
  const desktopHeader = (
    <React.Fragment>
      <div className='nav' data-testid='desktopHeader-component'>
        <span
          tabIndex='0'
          className='headerLogo'
          data-testid='desktop-navigate-handler'
          onClick={navigateHandler}
          onKeyPress={navigateHandler}
        >
          <ImageComponent
            srcFile={getValueOrDefaultAlternativeObject(kfcLogo.src, HeaderLogo)}
            alt={getValueOrDefaultAlternativeObject(kfcLogo.alt, 'KFC LOGO')}
          />
        </span>
        <span className='navItemsLeft'>{leftNavItems()}</span>
        <div className='navItemsRight'>{rightNavItems()}</div>
      </div>
    </React.Fragment>
  );
  return (
    <div data-testid={dataTestId} className='header-navs'>
      {getTernaryValue(isMobile, mobileHeader, desktopHeader)}
    </div>
  );
};
export default HeaderItems;
